import axios from 'axios'

function unwrapList(res) {
  const d = res?.data ?? res
  if (!d) return []
  if (Array.isArray(d)) return d
  if (Array.isArray(d.data)) return d.data
  if (Array.isArray(d.rows)) return d.rows
  if (Array.isArray(d.items)) return d.items
  if (d.data && typeof d.data === 'object') {
    const vals = Object.values(d.data).find(v => Array.isArray(v))
    if (vals) return vals
  }
  return []
}

function unwrapOne(res) {
  const d = res?.data ?? res
  if (!d) return null
  if (d.data && typeof d.data === 'object') return d.data
  return d
}

function str(v) {
  return String(v ?? '').trim()
}

const QueuesService = {
  async list(params = {}) {
    return axios.get('queues', { params })
  },

  async get(endpointId, params = {}) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing queue endpointId')
    return axios.get(`queues/${encodeURIComponent(id)}`, { params })
  },

  async create(payload = {}) {
    return axios.post('queues', payload)
  },

  async update(endpointId, payload = {}) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing queue endpointId')
    return axios.put(`queues/${encodeURIComponent(id)}`, payload)
  },

  async destroy(endpointId) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing queue endpointId')
    return axios.delete(`queues/${encodeURIComponent(id)}`)
  },

  // Full overwrite sync
  async syncMembers(endpointId, members = []) {
    const id = str(endpointId)
    if (!id) throw new Error('Missing queue endpointId')
    if (!Array.isArray(members)) throw new Error('members must be an array')

    // accept either:
    //  - { interface: 'PJSIP/TV...' }
    //  - { sip_user: 'TV...' }
    //  - { id/name/ext ... } (frontend junk) -> we’ll attempt to map ext -> sip_user if it looks like TV#####
    const clean = members
      .filter(m => m && typeof m === 'object')
      .map(m => {
        const iface = str(m.interface)
        const sip = str(m.sip_user || m.sipUser || m.UserID || m.user_id)

        const maybeExt = str(m.ext)
        const maybeTv = maybeExt.startsWith('TV') ? maybeExt : ''

        return {
          interface: iface || null,
          sip_user: sip || maybeTv || null,
          membername: str(m.membername || m.name) || null,
          penalty: Number.isFinite(m.penalty) ? Number(m.penalty) : 0,
          paused: !!m.paused,
          wrapuptime: Number.isFinite(m.wrapuptime) ? Number(m.wrapuptime) : (Number.isFinite(m.wrapupTime) ? Number(m.wrapupTime) : 0)
        }
      })
      .map(m => {
        // prune nulls to keep payload clean
        const out = {}
        if (m.interface) out.interface = m.interface
        if (m.sip_user) out.sip_user = m.sip_user
        if (m.membername) out.membername = m.membername
        if (Number.isFinite(m.penalty)) out.penalty = m.penalty
        out.paused = !!m.paused
        if (Number.isFinite(m.wrapuptime)) out.wrapuptime = m.wrapuptime
        return out
      })

    return axios.put(`queues/${encodeURIComponent(id)}/members`, { members: clean })
  },

  unwrapList,
  unwrapOne
}

export default QueuesService
